
const digest = 'c7c948c5e97b4e9e42b38c700eea0e80c44b03eb2ddf16249ace4fe89c9247cc';
const classes = {"wrapper":"_wrapper_fmm3s_1"};
const css = `._wrapper_fmm3s_1 {
  font-family: Rubik, "sans-serif";
  flex: 1;
  overflow: hidden;
  position: relative;
}
._wrapper_fmm3s_1 table {
  width: 100%;
}
._wrapper_fmm3s_1 table thead tr th {
  color: #3e3f42;
  font-size: 12px;
  font-weight: 400;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  